import { faClipboardList, faRotate, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { tss } from 'tss-react';

import { MenuPlannerItemsBulkResponse } from 'api/menuPlanner/GetMenuPlannerItemsBulk';
import { RecipeErpViewComponentProps } from 'components/desktop/ShoppingCart/Detail/Index';
import ReportModalContent from 'components/desktop/ShoppingCart/Detail/components/ReportModalContent/Index';
import SearchInput from 'components/desktop/ShoppingCart/Detail/misc/SearchInput';
import SourceItem from 'components/desktop/ShoppingCart/Detail/misc/SourceItem';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import Modal from 'components/desktop/_general/Modal/Modal';
import useTranslation from 'hooks/useTranslation';
import EntityType from 'types/ShoppingCart/EntityType';
import { ShoppingCart } from 'types/ShoppingCart/ShoppingCart';

interface IProps extends RecipeErpViewComponentProps {
	menuPlanOrders: MenuPlannerItemsBulkResponse[];
	refreshMenuPlanOrders: () => void;
}

const SourcesTab = (props: IProps) => {
	const { classes } = useStyles();
	const { state, handlers, cart } = props;
	const { t, cc } = useTranslation();
	const [reportModalIsOpen, setReportModalIsOpen] = useState<boolean>(false);
	const [refreshing, setRefreshing] = useState(false);

	const handleRefresh = async () => {
		setRefreshing(true);
		await props.refreshMenuPlanOrders();
		setRefreshing(false);
	};

	return (
		<div className={classes.container}>
			<RenderIf condition={Boolean(cart.appearances.length)}>
				<Modal
					wide={true}
					isOpen={reportModalIsOpen}
					close={() => setReportModalIsOpen(false)}
					headerIcon={<FontAwesomeIcon icon={faClipboardList} />}
					bodyContent={
						<ReportModalContent
							menuPlans={ShoppingCart.searchSources(cart, '', cc).filter(
								(source) => source.type == EntityType.MENUPLAN
							)}
							menuPlansOrders={props.menuPlanOrders}
							refreshMenuPlanOrders={handleRefresh}
						></ReportModalContent>
					}
					headerText={t('shoppingCart:MENU_PLAN_ORDERS_OVERVIEW')}
					buttonFull={{
						label: t('_general:BTN_LEAVE'),
						onClick: () => setReportModalIsOpen(false),
					}}
				/>
				<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
					<button
						className="btn btn-primary"
						onClick={() => setReportModalIsOpen(true)}
						style={{ width: '78%' }}
					>
						<FontAwesomeIcon icon={faClipboardList}></FontAwesomeIcon>{' '}
						{t('shoppingCart:MENU_PLAN_ORDERS_OVERVIEW')}
					</button>
					<button
						className="btn btn-outline-primary"
						onClick={handleRefresh}
						style={{ width: '20%' }}
						disabled={refreshing}
					>
						<FontAwesomeIcon
							icon={refreshing ? faSpinner : faRotate}
							spin={refreshing}
						/>{' '}
						{t('shoppingCart:REFRESH')}
					</button>
				</div>
				<SearchInput
					{...props}
					value={state.search.sources}
					handleChange={handlers.setSearchSources}
				/>
				<Accordion>
					{ShoppingCart.searchSources(cart, state.search.sources, cc).map(
						(item, itemKey) => {
							return (
								<SourceItem
									cart={cart}
									item={item}
									key={itemKey}
									itemKey={itemKey}
									itemOrders={
										props.menuPlanOrders?.find(
											(menuPlan) => menuPlan.menuplanId == item.id
										) || null
									}
								></SourceItem>
							);
						}
					)}
				</Accordion>
			</RenderIf>
			<RenderIf condition={!cart.appearances.length}>
				<h4>{t('shoppingCart:NO_SOURCES')}</h4>
			</RenderIf>
		</div>
	);
};

export default SourcesTab;

export const useStyles = tss.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
		marginTop: '20px',
	},
	item: {
		padding: '10px',
		border: '1px solid grey',
	},
	count: { fontWeight: 'lighter', fontStyle: 'italic' },
});
